import { render, staticRenderFns } from "./bindcard.vue?vue&type=template&id=367a1465&scoped=true&"
import script from "./bindcard.vue?vue&type=script&lang=js&"
export * from "./bindcard.vue?vue&type=script&lang=js&"
import style0 from "./bindcard.vue?vue&type=style&index=0&id=367a1465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a1465",
  null
  
)

export default component.exports